import React from "react";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  WPSelectIconSelect,
  WPSelectInput,
  WPSelectItem,
  WPSelectItemLeft,
  WPSelectItemLeftChildren,
  WPSelectItemRight,
  WPSelectItemRightIcon,
  WPSelectRowNameContainer,
} from "./styles";
import { useDispatch } from "react-redux";
import { updateProjectLabels } from "actions/projectLabels/editProjectLabels";
import { createProjectLabels } from "actions/projectLabels/createProjectLabels";
import { useTransition } from "react";
import { useTranslation } from "react-i18next";

const Item = ({
  item,
  index,
  isShowList,
  onClick = () => {},
  onRemove = () => {},
  handleUpdateLableReducer = (val) => {},
}) => {
  const refInput = React.useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const _handleBlur = () => {
    const inputValue = refInput.current.value;
    if (inputValue === item?.name) {
      return;
    } else if (item?.isNew) {
      console.log(
        dispatch(
          createProjectLabels({
            name: inputValue,
            color: item?.color,
          })
        )
      );
    } else {
      dispatch(
        updateProjectLabels({
          label_id: item.id,
          name: inputValue,
          color: item.color,
        })
      );
      handleUpdateLableReducer({
        id: item.id,
        name: inputValue,
        color: item.color,
      });
    }
  };

  return (
    <div>
      <WPSelectItem>
        <WPSelectItemLeft>
          <WPSelectItemLeftChildren>
            <WPSelectRowNameContainer>
              <WPSelectIconSelect
                color={item.color}
                onClick={(e) => onClick(e, item)}
              />
              <WPSelectInput
                ref={refInput}
                data-id={item._id}
                defaultValue={item.name}
                placeholder={t("Type an option name")}
                disabled={isShowList}
                onBlur={_handleBlur}
              />
            </WPSelectRowNameContainer>
          </WPSelectItemLeftChildren>
        </WPSelectItemLeft>
        <WPSelectItemRight>
          {!isShowList && (
            <WPSelectItemRightIcon onClick={() => onRemove(item.id, item)}>
              <svg
                className="MiniIcon XMiniIcon"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <path d="M13.4,12l7.5-7.5c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L12,10.6L4.5,3.1c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l7.5,7.5l-7.5,7.5 c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l7.5-7.5l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12z" />
              </svg>
            </WPSelectItemRightIcon>
          )}
        </WPSelectItemRight>
      </WPSelectItem>
    </div>
  );
};

export default React.memo(Item);
